
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/pbe",
      function () {
        return require("private-next-pages/info/pbe.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/pbe"])
      });
    }
  